// src/routes/PrivateRoute.jsx
import React from "react";
import { Navigate, Outlet, useLocation } from "react-router";
import { Spin } from "antd";
import { useAuth } from "../auth/AuthProvider";

export default function PrivateRoute() {
  const { isAuthed, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div style={{ minHeight: "60vh", display: "grid", placeItems: "center" }}>
        <Spin />
      </div>
    );
  }
  // Giriş yoksa login'e yönlendir ve geldiği adresi state ile taşı
  return isAuthed ? (
    <Outlet />
  ) : (
    <Navigate to="/login" replace state={{ from: location }} />
  );
}
